(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for one agenda appointment 
    module.directive('onEnter', [function () {
        var directive = {
            restrict: 'A',
            scope: {
                enterAction: '&',
                invalid: '='
            },
            link: link
        };
        return directive;

        function link(scope, element) {
            element.attr("tabIndex", "1");
            element.css("outline", "none");


            // listen on key-down event
            element.on('keydown', function (event) {
                if (event.which === 13) {
                    // check if valid
                    if (scope.invalid) { return; }                    
                    event.preventDefault();
                    event.stopPropagation();
                    scope.enterAction();                    
                } //if               
            });

           

            // destroy
            scope.$on('$destroy', function () {
                element.off("keyup");
            });

        }


    }]);

})();